import React, { useState, useCallback } from "react";
import Text from "../Text";
import * as colors from "../../assets/_base/colors";
import styled, { css } from "styled-components";

const DraggingArea = styled.div`
  border: 2px dashed ${colors.lightBlue};
  opacity: 0.5;
  padding: 20px;
  border-radius: 15px;
  cursor: pointer;
  margin: 20px;

  input {
    display: none;
  }

  ${(props) => {
    if (props.dragging) {
      return css`
        border: 2px dashed ${colors.lightBlue};
        opacity: 0.8;
      `;
    }
    if (props.file.name) {
      return css`
        border: 2px dashed ${colors.primary};
        opacity: 1;
      `;
    }
  }}
`;

const DragAndDropUpload = (props) => {
  const [dragging, setDragging] = useState(false);
  const [file, setFile] = useState({});
  const inputRef = React.useRef();

  const handleDrop = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      props.onDrop(file);
      event.dataTransfer.clearData();
      setFile(file);
    }
  }, []);
  const handleDragOver = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!dragging) {
        setDragging(true);
      }
    },
    [dragging]
  );
  const handleDragLeave = useCallback(() => {
    setDragging(false);
  }, []);

  const handleChangeInput = (e) => {
    const file = e.target.files[0];
    props.onDrop(file);
    setFile(file);
  };

  return (
    <DraggingArea
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      file={file}
      dragging={dragging}
      onClick={() => {
        inputRef.current.click();
      }}
    >
      <Text align="center">
        {file.name
          ? file.name
          : "Arraste e solte o arquivo aqui, ou clique para selecionar um arquivo."}
      </Text>
      <input onChange={handleChangeInput} ref={inputRef} type="file" />
    </DraggingArea>
  );
};

export default DragAndDropUpload;



// WEBPACK FOOTER //
// ./src/_components/DragAndDrop/index.jsx